<loading-contents *ngIf="allItems == null || itemDetails == null"></loading-contents>
<div class="wrapper" *ngIf="allItems != null && itemDetails != null">
    <div class="top-banner">
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="media">
                        <div class="media-body">
                            <h1 class="mt-0 text-center">{{itemTitle}}</h1>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="media">
                        <img src="../../assets/images/{{postType}}/thumbnail/{{itemThumbnail}}" width="120" class="mr-3" alt="{{itemTitle}}">
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="details">
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="item-images padding-bottom-30">
                        <owl-carousel-o [options]="customOptions"> 
                            <ng-template carouselSlide *ngFor="let image of itemImages">
                                <div class="slide">
                                    <img src="../../assets/images/{{postType}}/{{image}}">
                                </div>      
                            </ng-template>        
                        </owl-carousel-o>
                    </div>                    
                </div>
                <div class="col-md-4">
                    <div *ngIf="postType == 'websites'" class="item-details">
                        <h4>{{itemTitle}}</h4>
                        <p>{{itemDescription}}</p>
                        <div class="designer" *ngIf="itemDesigner != ''">
                            <p *ngIf="itemDesignerUrl">
                                <span class="bold">Design by: </span><a href="{{itemDesignerUrl}}" target="new">{{itemDesigner}}</a>
                            </p>
                            <p *ngIf="!itemDesignerUrl">
                                <span class="bold">Design by: {{itemDesigner}}</span>
                            </p>
                        </div>
                        <div class="designer" *ngIf="itemLink != ''">
                            <p><span class="bold">View site: </span><a href="{{itemLink}}" target="new">{{itemTitle}}</a></p>
                        </div>
                        <div class="designer" *ngIf="itemType != ''">
                            <p><span class="bold">Build by: </span>{{itemType}}</p>
                        </div> 
                        <div>
                            <button class="btn btn-outline-light btn-sm" (click)="goBack()"><fa-icon [icon]="faArrowLeft"></fa-icon> Back</button>
                        </div>
                    </div>
                    <div *ngIf="postType === 'photography'" class="item-details">
                        <h4 *ngIf="itemType != 'Landscape'">{{itemTitle}}</h4>
                        <p *ngIf="itemType === 'Landscape'">Photo location: {{itemTitle}}</p>
                        <div *ngIf="itemLocation && center" class="location-map padding-bottom-15 speech-bubble">
                            <google-map
                                height="300px"
                                width="100%"
                                [center]="center"
                                [zoom]="zoom"
                                [options]="mapOptions"
                                (mapClick)="mapClicked($event)">
                                <map-marker
                                    *ngFor="let m of markers; let i = index"
                                    #marker="mapMarker"
                                    [position]="m.position"
                                    [label]="m.label"
                                    [options]="{ draggable: m.draggable }"
                                    (mapClick)="clickedMarker(m.label, i, marker)"
                                    (mapDragend)="markerDragEnd(m, $event)">
                                </map-marker>
                                <map-info-window>
                                    <strong>{{ selectedMarkerLabel }}</strong>
                                </map-info-window>
                                <map-circle
                                    [center]="center"
                                    [radius]="circleOptions.radius"
                                    [options]="circleOptions">
                                </map-circle>
                            </google-map>
                            <div class="speech-bubble-arrow"></div>
                        </div>
                        <div *ngIf="itemDescription != ''" [ngClass]="{'speech-bubble':itemType === 'Portrait'}">
                            <p>{{itemDescription}}</p>
                            <div class="speech-bubble-arrow" *ngIf="itemType === 'Portrait'"></div>
                        </div>
                        <div class="designer" *ngIf="itemType != ''">
                            <p>{{itemType}} Photography</p>
                        </div> 
                        <div>
                            <button class="btn btn-outline-light btn-sm" (click)="goBack()"><fa-icon [icon]="faArrowLeft"></fa-icon> Back</button>
                        </div>
                    </div>
                </div>
            </div>        
        </div>
    </div>
    <div class="all-items-list">
        <div class="container">
            <div class="row">
                <div class="p-3 mb-2 bg-white text-dark">
                    <h5>Other {{itemType}} 
                        <span *ngIf="totalItems > 1">Sites</span>
                        <span *ngIf="totalItems < 2">Site</span>
                    </h5>
                </div>
            </div>            
            <div class="" *ngIf="allItems">
                <div class="row" *ngIf="totalItems < 4">
                    <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6" *ngFor="let item of allItems">
                        <div class="card">
                            <div class="image-wrapper">
                                <img src="../../assets/images/{{postType}}/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                            </div>                                
                            <div class="card-body">
                                <div class="body-wrapper">
                                    <a *ngIf="postType == 'websites'" class="itemTitle" href="/web/{{item.url}};type={{itemType}};postType={{postType}}">
                                        <h6>{{item.title}}</h6>
                                    </a>
                                    <a *ngIf="postType == 'photography'" class="itemTitle" href="/photography/{{item.url}};type={{itemType}};postType={{postType}}">
                                        <h6>{{item.title}}</h6>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="totalItems > 3">
                    <owl-carousel-o [options]="allSitesOption"> 
                        <ng-template carouselSlide *ngFor="let item of allItems">
                            <div class="slide">
                                <div class="card">
                                    <div class="image-wrapper">
                                        <img src="../../assets/images/{{postType}}/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                                    </div>                                
                                    <div class="card-body">
                                        <div class="body-wrapper">
                                            <a *ngIf="postType == 'websites'" class="itemTitle" href="/web/{{item.url}};type={{itemType}};postType={{postType}}">
                                                <h6>{{item.title}}</h6>
                                            </a>
                                            <a *ngIf="postType == 'photography'" class="itemTitle" href="/photography/{{item.url}};type={{itemType}};postType={{postType}}">
                                                <h6>{{item.title}}</h6>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>      
                        </ng-template>        
                    </owl-carousel-o>
                </div>
            </div>
        </div>
    </div>
</div>